import React from "react";
import MDBox from "components/MDBox";
import SendNotification from "./components/notification";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
function Notification() {
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox sx={{ display: "flex", justifyContent: "center" }}>
        <SendNotification />
      </MDBox>
    </DashboardLayout>
  );
}

export default Notification;
